import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../modules/modal/modal-ref";
import {TypeUtils} from "../../../shared/utils/type-utils";
import {Router} from "@angular/router";
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {first, map, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {Observable} from "rxjs";

@Component({
    selector: 'db-download-manager-recreate',
    templateUrl: './download-manager-recreate.component.html',
    styleUrls: ['./download-manager-recreate.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DownloadManagerRecreateComponent implements OnInit {

  public downloadLink$: Observable<string> = this._managerLink();

  constructor(
    private readonly _activeModal: DbActiveModal,
    private readonly _router: Router,
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this._activeModal.resize(330, 940);
  }

  private _managerLink(): Observable<string> {
    return this._store.select(fromStore.getTenWebProductsLoaded)
      .pipe(
        first(loaded => loaded),
        switchMap(() => this._store.select(fromStore.getTenWebManagerPlugin)),
        map(managerPlugin => managerPlugin && managerPlugin.downloadLink || ''),
        first(downloadLink => !!downloadLink)
      );
  }

  public downloadManagerPluginEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: '10Web Manager Download',
      eventLabel: TypeUtils.isDefined(this._router.url) ? this._router.url : 'add-website-manually'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
